<template>
	<div class="add_backimg add_backimgTop exam_all_back">
		<div class="exam_banner clearfix">
			<img src="@/images/exam_banner.png" />
		</div>
		<div class="content content_exam content_exam_hasTabs minheight">
			<div class="content_exam_tabs">
				<div class="content_exam_tab" @click="activeName = 'first'" :class="activeName == 'first'?'active':''">
					<img src="@/images/content_exam_tab1.png" /> 理论考试
				</div>
				<div class="content_exam_tab" @click="activeName = 'second'" :class="activeName == 'second'?'active':''">
					<img src="@/images/content_exam_tab2.png" /> 实验考试
				</div>
			</div>
			<div class="exam_content" v-show="activeName == 'first'">
				<div class="exam_label">
					<div class="exam_labelItem">考试名称</div>
					<div class="exam_labelItem exam_labelItemFix">考试时间段</div>
					<div class="exam_labelItem">考试时长</div>
					<div class="exam_labelItem">
						<div class="pointer" @click.stop="typeShow = !typeShow">
							<span v-if="examForm.state == null || examForm.state == ''">考试状态</span>
							<span v-if="examForm.state == item.id" v-for="item in types">{{item.name}}</span>
							<i class="el-icon-arrow-down"></i>
						</div>
						<div class="exam_labelItemSele" v-show="typeShow">
							<div @click.stop="typeChange(item.id)" class="exam_seleItem" v-for="item in types">{{item.name}}</div>
						</div>
					</div>
					<div class="exam_labelItem ">操作</div>
				</div>
				<div class="exam_list">
					<emptymain :emptytext="'暂无考试'" :emptylist='examForm.dataList'></emptymain>
					<div class="exam_item" :class="'exam_item'+item.state" v-for="(item,index) in examForm.dataList">
						<div class="exam_itemTb exam_itemName exam_itemBack">
							<img src="@/images/exam_itemName.png" />
							<div class="text-ellipsis">{{item.name}}</div>
						</div>
						<div class="exam_itemTb exam_itemTbFix exam_itemTime">
							<div class="exam_itemTime1">{{item.beginTime | spliceForTask}}</div>
							<div class="exam_itemTime2">-</div>
							<div class="exam_itemTime1">{{item.endTime | spliceForTask}}</div>
						</div>
						<div class="exam_itemTb exam_itemBack">
							{{item.timeSpent || '-'}}分钟
						</div>
						<div class="exam_itemTb exam_itemStatus ">
							<span v-if='item.state == 0'><img src="@/images/exam_status0.png"/>考试中</span>
							<span v-if='item.state == 1'><img src="@/images/exam_status1.png"/>考试结束</span>
							<span v-if='item.state == 2' class='infoColor'><img src="@/images/exam_status2.png"/>考试异常</span>
							<span v-if='item.state == 3' class='infoColor'><img src="@/images/exam_status2.png"/>未参考</span>
						</div>
						<div class="exam_itemTb exam_itemBack">
							<div v-if='item.state == 0' @click="startexamine(item)" class="exam_itemBtn exam_itemBtn0" :class="getDisabld(item)?'disabled':''">开始考试</div>
							<div v-if='item.state == 1' @click="examineit(item)" class="exam_itemBtn">查看详情</div>
							<span v-if='item.state == 2' class='infoColor'>-</span>
							<div v-if='item.state == 3' @click="startexamine(item)" class="exam_itemBtn exam_itemBtn0" :class="getDisabld(item)?'disabled':''">开始考试</div>
						</div>
					</div>
				</div>
				<div class="all_current">
					<el-pagination prev-text='上一页' next-text='下一页' background @current-change="examinePageChange" :current-page="examForm.current" :page-size="examForm.limit" layout="total, prev, pager, next" :total="examForm.totalRow">
					</el-pagination>
				</div>
			</div>
			<div class="clearfix" v-show="activeName == 'second'">
				<emptymain :emptytext="'暂无考试'" :emptylist='vrForm.dataList'></emptymain>
				<div class="exam_vr_item" @click="startexamineVr(item)" v-for="(item,index) in vrForm.dataList">
					<div class="exam_vr_itemicon">
						<img src="@/images/exam_vr_itemback.png" class="exam_vr_itemback" />
						<div class="exam_vr_itemicon_title text-ellipsis">{{item.vrExamineName}}</div>
						<div class="exam_vr_itemicon_desc text-ellipsis">{{item.startTime | spliceForTask}} - {{item.endTime | spliceForTask}}</div>
						<img src="@/images/exam_vr_itemicon.png" class="exam_vr_itemicon_it" />
						<div class="exam_vr_itemicon_state">
							{{getDisabldVrText(item)}}
						</div>
					</div>
					<div class="exam_vr_itemp1 text-ellipsis">{{item.vrExamineName}}</div>
					<div class="exam_vr_itemp2 text-ellipsis">
						实验总分：{{item.totalScore}}
						<span></span> 实验及格分：{{item.passScore}}
					</div>
					<div class="exam_vr_itemp3 text-ellipsis">
						得分：
						<span class="exam_vr_itemp3_big">{{item.score || '-'}}</span>
						<span class="r ">
							已完成：<span class="exam_vr_itemp3_big"><span class=" primaryColor">{{item.commitNumber}}</span>/{{item.extractNumber}}</span>
						</span>
					</div>
				</div>
				<div class="all_current">
					<el-pagination prev-text='上一页' next-text='下一页' background @current-change="vrPageChange" :current-page="vrForm.current" :page-size="vrForm.limit" layout="total, prev, pager, next" :total="vrForm.totalRow">
					</el-pagination>
				</div>
			</div>
		</div>
		<el-dialog title="实验考试" class="open_dialogInfo" :visible.sync="examOpen" :append-to-body='true' width="950px" :close-on-click-modal='false' :close-on-press-escape='false'>
			<vrlist @startVrExam='startVrExam' v-if='examOpen' :vrExamineInfo='vrExamineInfo' :vrExamineId='vrExamineId'></vrlist>
		</el-dialog>
	</div>
</template>

<script>
	import { getLoginUserExamList } from '@/api/examine'
	import { vrExamineStudentList } from '@/api/vrExamUser.js'
	import vrlist from '@/views/examine/vrlist.vue'
	export default {
		components: {
			vrlist,
		},
		data() {
			return {
				activeName: this.$route.query.activeName || 'first',
				examForm: {
					current: 1,
					limit: 10,
					totalRow: 0,
					dataList: [],
					examineName: '',
					state: null,
				},
				vrForm: {
					current: 1,
					limit: 10,
					totalRow: 0,
					dataList: [],
					examineName: '',
					state: null,
				},
				vrExamineId: '',
				vrExamineInfo: {},
				examOpen: false,
				typeShow: false,
				stateShow: false,
				types: [{
					id: '0',
					name: '考试中'
				}, {
					id: '1',
					name: '考试结束'
				}, {
					id: '2',
					name: '考试异常'
				}, {
					id: '3',
					name: '未参考'
				}],
				states: [{
					id: '1',
					name: '已参考'
				}, {
					id: '2',
					name: '未参考'
				}],
			}
		},
		created() {
			this.getExamList();
			this.getVrList();
		},
		mounted() {
			var that = this;
			window.onfocus = function() {
				that.getVrList();
			}
		},
		methods: {
			stateChange(state) {
				if(this.vrForm.state != state) {
					this.vrForm.state = state;
				} else {
					this.vrForm.state = null;
				}
				this.stateShow = false;
				this.vrForm.current = 1;
				this.getVrList();
			},
			getDisabldVr(item) {
				if(item.startTime && item.endTime) {
					var nowTime = new Date();
					var startTime = new Date(item.startTime);
					var endTime = new Date(item.endTime);
					if(nowTime > startTime && nowTime < endTime) {
						return false
					} else {
						return true
					}
				} else {
					return true
				}
			},
			getDisabldVrText(item) {
				var nowTime = new Date();
				var startTime = new Date(item.startTime);
				var endTime = new Date(item.endTime);
				if(nowTime < startTime) {
					return '未开始'
				}
				if(nowTime >= endTime) {
					return '已结束'
				}
				if(nowTime >= startTime && nowTime < endTime) {
					return '进行中'
				}
			},
			startexamineVr(item) {
				this.vrExamineId = item.vrExamineId;
				this.vrExamineInfo = item;
				this.examOpen = true;
			},
			examineitVr(item) {
				this.vrExamineId = item.vrExamineId;
				this.vrExamineInfo = item;
				this.examOpen = true;
			},
			startVrExam() {
				this.vrExamineId = '';
				this.vrExamineInfo = {};
				this.examOpen = false;
			},
			vrPageChange(current) {
				this.vrForm.current = current;
				this.getVrList()
			},
			getVrList() {
				var data = {
					current: this.vrForm.current,
					limit: this.vrForm.limit,
					examineName: this.vrForm.examineName,
					state: this.vrForm.state,
				}
				vrExamineStudentList(data).then(res => {
					if(res.code == "OK") {
						this.vrForm.dataList = res.data.records;
						this.vrForm.totalRow = res.data.total;
					}
				})
			},
			typeChange(state) {
				if(this.examForm.state != state) {
					this.examForm.state = state;
				} else {
					this.examForm.state = null;
				}
				this.typeShow = false;
				this.examForm.current = 1;
				this.getExamList();
			},
			getDisabld(item) {
				if(item.beginTime && item.endTime) {
					var nowTime = new Date();
					var beginTime = new Date(item.beginTime);
					var endTime = new Date(item.endTime);
					if(nowTime > beginTime && nowTime < endTime) {
						return false
					} else {
						return true
					}
				} else {
					return true
				}
			},
			startexamine(item) {
				var nowTime = new Date();
				var beginTime = new Date(item.beginTime);
				var endTime = new Date(item.endTime);
				if(nowTime < beginTime) {
					this.$message({
						type: 'info',
						message: '考试时间未到！',
					})
					return;
				}
				if(nowTime > endTime) {
					this.$message({
						type: 'info',
						message: '考试时间已结束！',
					})
					return;
				}
				this.$router.push({
					name: 'examineinfo',
					query: {
						id: item.id
					}
				})
			},
			examineit(item) {
				this.$router.push({
					name: 'examdetails',
					query: {
						id: item.id
					}
				})
			},
			examinePageChange(current) {
				this.examForm.current = current;
				this.getExamList()
			},
			getExamList() {
				var data = {
					current: this.examForm.current,
					limit: this.examForm.limit,
					examineName: this.examForm.examineName,
					state: this.examForm.state,
				}
				getLoginUserExamList(data).then(res => {
					if(res.code == "OK") {
						this.examForm.dataList = res.data.records;
						this.examForm.totalRow = res.data.total;
					}
				})
			},
		},
		beforeRouteLeave(to, from, next) {
			window.onfocus = function() {}
			next();
		},
	}
</script>